import { useNextVermut } from '@/hooks/useBarStatus';

function Block({ value, label }) {
  return (
    <div className="vc-b">
      <span className="vc-n">{String(value).padStart(2, '0')}</span>
      <span className="vc-l">{label}</span>
    </div>
  );
}

function InlineLabel({ live, diff }) {
  if (live) return <><span className="vc-pulse" /> Vermut en marcha · hasta las 16:00</>;
  if (!diff) return 'Próximo vermut · domingo 11:00';
  const hh = String(diff.h).padStart(2, '0');
  const mm = String(diff.m).padStart(2, '0');
  return `Próximo vermut · ${diff.d}d ${hh}h ${mm}m`;
}

function CardBody({ live, diff }) {
  if (live) {
    return (
      <div className="vc-live-msg">
        <h3>Estamos sirviendo</h3>
        <p>Vermut de grifo y gildas. Hasta las 16:00.</p>
      </div>
    );
  }
  if (!diff) return null;
  return (
    <div className="vc-blocks" aria-label="Cuenta atrás al próximo vermut">
      <Block value={diff.d} label="días" />
      <Block value={diff.h} label="horas" />
      <Block value={diff.m} label="min" />
      <Block value={diff.s} label="seg" />
    </div>
  );
}

export default function VermutCountdown({ variant = 'card' }) {
  const { live, diff } = useNextVermut();

  if (variant === 'inline') {
    return (
      <span className={`vc-inline ${live ? 'live' : ''}`} data-testid="vermut-countdown-inline">
        <InlineLabel live={live} diff={diff} />
      </span>
    );
  }

  return (
    <div className={`vc-card ${live ? 'live' : ''}`} data-testid="vermut-countdown">
      <div className="vc-eyebrow">
        {live ? <><span className="vc-pulse" /> En marcha ahora</> : 'Próximo vermut del domingo'}
      </div>
      <CardBody live={live} diff={diff} />
      <p className="vc-foot">Domingos · 11:00 — 16:00 · Vermut de grifo, gildas y mejor compañía</p>
    </div>
  );
}
